import gql from "graphql-tag";

import { TypedQuery } from "../queries";
import { Home } from "./types/Home";
import { HomeVariables } from "./types/Home";

const home = gql`
  query Home($language: String) {
    salesToday: ordersTotal(period: TODAY, language: $language) {
      gross {
        amount
        currency
      }
    }
    salesYesterday: ordersTotal(period: YESTERDAY, language: $language) {
      gross {
        amount
        currency
      }
    }
    ordersToday: orders(
      status: UNFULFILLED
      created: TODAY
      language: $language
    ) {
      totalCount
    }
    ordersYesterday: orders(
      status: UNFULFILLED
      created: YESTERDAY
      language: $language
    ) {
      totalCount
    }
    ordersPendingToday: orders(
      status: PENDING
      created: TODAY
      language: $language
    ) {
      totalCount
    }
    ordersPendingYesterday: orders(
      status: PENDING
      created: YESTERDAY
      language: $language
    ) {
      totalCount
    }
    ordersToFulfill: orders(status: READY_TO_FULFILL, language: $language) {
      totalCount
    }
    ordersToCapture: orders(status: READY_TO_CAPTURE, language: $language) {
      totalCount
    }
    productsOutOfStock: products(stockAvailability: OUT_OF_STOCK) {
      totalCount
    }
    productvariantsOutOfStock: soldoutInCustompage(first: 100) {
      totalCount
    }
    productTopToday: reportProductSales(
      period: TODAY
      first: 10
      language: $language
    ) {
      edges {
        node {
          id
          # revenue(period: TODAY) {
          #   gross {
          #     amount
          #     currency
          #   }
          # }
          attributes {
            values {
              id
              name
            }
          }
          product {
            id
            name
            quantityOrdered(period: TODAY, language: $language)
            revenue(period: TODAY, language: $language) {
              gross {
                amount
                currency
              }
            }
            thumbnail {
              url
            }
          }
          quantityOrdered
        }
      }
    }
    activities: homepageEvents(last: 10, language: $language) {
      edges {
        node {
          amount
          composedId
          date
          email
          emailType
          id
          message
          orderNumber
          oversoldItems
          quantity
          type
          user {
            id
            email
          }
        }
      }
    }
  }
`;
export const HomePageQuery = TypedQuery<Home, HomeVariables>(home);
